webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jim.f306a5e.png";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qasar.c4d0d5a.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tuobuhua.3fbf07c.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xiaowenjie.31dbe60.png";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhangying.f290727.png";

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var oldGuests = [{ 'name': 'QasarYounis', 'title': 'Y Combinator', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/qasar.png' }, { 'name': 'Ashish Sharma', 'title': 'Paytm', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/ashish.png' }, { 'name': 'Vikas Banga', 'title': 'Snapdeal', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/vikas.png' }, { 'name': 'Ophir Gore', 'title': '以色列驻华使馆', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/ophir.png' }, { 'name': 'Dovi Ollech', 'title': 'E.MERGR Fund', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/dovi.png' }, { 'name': 'Justin Kan', 'title': 'Y Combinator', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/justin.png' }, { 'name': '张颖', 'title': '经纬中国', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/zhangying.png' }, { 'name': '朱啸虎', 'title': '金沙江创投', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/zhuxiaohu.png' }, { 'name': '戴威', 'title': 'ofo共享单车', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/daiwei.png' }, { 'name': '吴海燕', 'title': '华创资本', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/wuhaiyan2.png' }, { 'name': '宿华', 'title': '快手', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/suhua.png' }, { 'name': '肖文杰', 'title': '分期乐', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/xiaowenjie.png' }];
/* harmony default export */ __webpack_exports__["a"] = (oldGuests);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


var util = {
    resource: function resource(options) {
        if (!options.data) {
            options.data = {};
        }
        if (!options.method) {
            options.method = 'get';
        }
        if (options.method == 'get') {
            options.data = {
                params: options.data
            };
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http[options.method](options.url, options.data).then(function (res) {
            return res.json();
        }).then(function (res) {
            options.success(res);
        });
    },

    getWx: function getWx() {
        var _this = this;
        var data = {
            url: location.href,
            csrfmiddlewaretoken: $('.login-container input').val()
        };
        $.ajax({
            url: '/api/website/signature/weixin/',
            type: 'post',
            data: data,
            success: function success(res) {
                _this.callBack(res.data);
            }
        });
    },

    callBack: function callBack(data) {
        var wxurl = location.href;
        var wxtitle = "2020小饭桌青年创业者大会，在这里“预见”未来";
        var wxdes = "11月26日，北京千禧酒店";
        var wximg = "https://static-miniapp.xfz.cn/xiaofanzhuologo.jpg";

        wx.config({
            debug: false,
            appId: data.app_id,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        });
        wx.ready(function () {
            wx.onMenuShareTimeline({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                success: function success() {},
                cancel: function cancel() {}
            });
            wx.onMenuShareAppMessage({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                type: '',
                dataUrl: '',
                success: function success() {},
                cancel: function cancel() {}
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(41)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/main_ticket.41f58ee.png";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/more.535e4b8.png";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.da50f9f.png";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.725a72e.png";

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  "data-v-6953b264",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  "data-v-1fbe3a86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(38)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  "data-v-261aa552",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(26),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  "data-v-311c0164",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-mobile"
    }
  }, [_c('a', {
    attrs: {
      "name": "s-home",
      "id": "s-home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "just-a-wrap"
  }, [_vm._m(0), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "section-guest"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest, index) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾姓名"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name-title"
    }, [_c('div', {
      staticClass: "g-name"
    }, [_vm._v(" " + _vm._s(guest.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "g-title"
    }, [_vm._v(" " + _vm._s(guest.position) + " ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "agenda-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "section agenda",
    attrs: {
      "id": "section-agenda"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-agenda"
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.agendaData.type[0]) ? _vm._l((_vm.agendaData.type[0]), function(key, index) {
    return _c('div', {
      class: 'agenda-item-' + index
    }, [(false) ? _c('div', {
      staticClass: "conf-host",
      class: 'conf-host-' + index
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(key)
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "agenad-list"
    }, [_vm._l((_vm.agendaData.meeting[key]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "type": key,
          "index": index
        }
      })]
    })], 2)])
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "time-address"
  }, [_vm._v("时间：2020年11月26日   地点：北京千禧大酒店二层大宴会厅")])], 2)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "section partners"
  }, [_c('a', {
    attrs: {
      "name": "s-partners",
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "name": "s-partners"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "up-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }), 0)]
    })]
  })], 2)])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "section about-us"
  }, [_c('a', {
    attrs: {
      "name": "s-contact-us",
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px"
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), (false) ? _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.xfz.cn/static/build/images/xfz-school-wechat-share.png"
    }
  }), _vm._v(" "), _vm._m(16)]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBottomNav) ? _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v(" 邀请嘉宾 ")]), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v(" 大会议程 ")]), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._v(" 参会购票 ")]), _vm._v(" "), (false) ? _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "target": "_blank",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl
    }
  }) : _vm._e()])]) : _vm._e()])], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "new-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.newsUrl
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/f-pc/live-logo.png")
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner",
    attrs: {
      "id": "section-banner"
    }
  }, [_c('div', {
    staticClass: "intro-content"
  }, [_c('div', {
    staticClass: "intro-normal"
  }, [_vm._v("\n                    小饭桌青年创业者大会此前已成功举办四届，是创投圈TOP级别的年度盛宴。第5届小饭桌青年创业者大会以“乘风破浪，逆风而行”为主题，聚焦创投圈，关注新风向，深度剖析全年新经济发展态势，预见下一年机会所在，是一场属于创业者和投资人的盛会。\n                    "), _c('br'), _c('br'), _vm._v("\n                    在不确定的市场寻找确定性的机会\n                    "), _c('br'), _c('br'), _vm._v("\n                    在没有英雄主义的时代选出推动经济变革的英雄\n                    "), _c('br'), _c('br'), _vm._v("\n                    好风凭借力，送我上青云，小饭桌与你一起预见2021\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" PAST GUEST")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v("邀请嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 大会议程 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("奖项评选")])])]), _vm._v(" "), _c('div', {
    staticClass: "award-list-wrap"
  }, [_c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/gy0mOM"
    }
  }, [_vm._v("2020年度准独角兽企业TOP 30")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/o0V6w5"
    }
  }, [_vm._v("2020年度 30 under 30 新锐投资人 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/ZaCdGH"
    }
  }, [_vm._v("2020年度新消费领域新锐投资人TOP 10 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/g3u3PY"
    }
  }, [_vm._v("2020年度企业服务领域新锐投资人TOP 10 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/P5EOnU"
    }
  }, [_vm._v("2020年度工业互联网领域新锐投资人TOP 10")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v("参会人员分析")])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会购票 ")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets-content"
  }, [_c('a', {
    staticClass: "ticket-item",
    attrs: {
      "href": "https://www.huodongxing.com/event/1567573387600",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("往届回顾")])])]), _vm._v(" "), _c('div', {
    staticClass: "old-version"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2019/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/bufan2018/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2017/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2016/"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会指南 ")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 购票什么时候截止? ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 购票截止日期为 2020年11月25日，中午12:00 ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 购票付款成功后，如何获得参会凭证？ ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。"), _c('br'), _vm._v("活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌微信公众号，届时也会有相应提醒。 ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？ ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 请您核对票务权益，限量体验票、早鸟票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。 ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 大会场馆附近有就餐的地方吗？ ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" 酒店1层设有自助餐厅；距会场2-5分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。 ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                                1) 大会门票仅为“999元”票档开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                                2) 开票内容为：会议服务费； "), _c('br'), _vm._v("\n                                3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 合作机构 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('a', {
    attrs: {
      "name": "s-location",
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 会议地址 ")])]), _vm._v(" "), _c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        地铁10号线：金台夕照站 A口出，西行420米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        自驾：北京市朝阳区东三环中路七号，千禧大酒店\n                    ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 联系我们 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("白怡-Nina")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("159-0133-7648")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("baiyi@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注小饭桌")])])
}]}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-pc"
    }
  }, [_c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "header-wrap-id"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-summary"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#past-guest"
    }
  }, [_vm._v("往期嘉宾")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v("邀请嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._v("参会购票")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-content"
  }, [_vm._m(0), _vm._v(" "), (false) ? _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" TRUST 相信，相信的力量！")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guest-bg-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "guest-wrap-id"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest, index) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "left-top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-bottom"
    }, [_c('div', {
      staticClass: "g-name"
    }, [_vm._v(" " + _vm._s(guest.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "g-title"
    }, [_vm._v(" " + _vm._s(guest.position) + " ")])])])])
  }), 0)])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "agenda-title-bottom"
  }), _vm._v(" "), _vm._l((_vm.agendaData.type[0]), function(type, index) {
    return [_c('div', {
      class: 'agenda-group-' + index
    }, [_c('div', {
      staticClass: "agenda-group-center",
      class: 'agenda-group-center-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'agenda-theme-' + index
    }, [(false) ? _c('div', {
      staticClass: "which-conf"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(type)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "see-map",
      attrs: {
        "href": "http://j.map.baidu.com/h4z9P",
        "target": "_blank"
      }
    }, [_vm._v("查看地图")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "agenda-list"
    }, [_vm._l((_vm.agendaData.meeting[type]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "type": type,
          "index": index
        }
      })]
    })], 2)])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "time-address"
  }, [_vm._v("时间：2020年11月26日         地点：中国北京·千禧大酒店二层大宴会厅")])], 2)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    attrs: {
      "id": "partners-bg-area"
    }
  }, [_c('div', {
    staticClass: "section partners"
  }, [_c('p', {
    attrs: {
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }), 0)]
    })]
  })], 2)])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "section about-us"
  }, [_c('p', {
    attrs: {
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), (false) ? _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.xfz.cn/static/build/images/xfz-school-wechat-share.png"
    }
  }), _vm._v(" "), _vm._m(18)]) : _vm._e()])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.newsUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/f-pc/live-logo.png")
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-normal"
  }, [_vm._v("\n            小饭桌青年创业者大会此前已成功举办四届，是创投圈TOP级别的年度盛宴。第5届小饭桌青年创业者大会以“乘风破浪，逆风而行”为主题，聚焦创投圈，关注新风向，深度剖析全年新经济发展态势，预见下一年机会所在，是一场属于创业者和投资人的盛会。\n            "), _c('br'), _c('br'), _vm._v("\n            在不确定的市场寻找确定性的机会\n            "), _c('br'), _c('br'), _vm._v("\n            在没有英雄主义的时代选出推动经济变革的英雄\n            "), _c('br'), _c('br'), _vm._v("\n            好风凭借力，送我上青云，小饭桌与你一起预见2021\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("已邀嘉宾")]), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("按出场顺序排")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section agenda-2"
  }, [_c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("大会议程")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static-miniapp.xfz.cn/2019-agenda-2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("大会议程")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("奖项评选")])])]), _vm._v(" "), _c('div', {
    staticClass: "award-list-wrap"
  }, [_c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/gy0mOM"
    }
  }, [_vm._v("2020年度准独角兽企业TOP 30")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/o0V6w5"
    }
  }, [_vm._v("2020年度 30 under 30 新锐投资人 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/ZaCdGH"
    }
  }, [_vm._v("2020年度新消费领域新锐投资人TOP 10 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/g3u3PY"
    }
  }, [_vm._v("2020年度企业服务领域新锐投资人TOP 10 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/P5EOnU"
    }
  }, [_vm._v("2020年度工业互联网领域新锐投资人TOP 10")])]), _vm._v(" "), _c('div', {
    staticClass: "award-content"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("参会人群分析")])])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  }, [_c('div', {
    staticClass: "partici-img"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tickets-bg-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("参会购票")])])]), _vm._v(" "), _c('a', {
    staticClass: "tickets-content",
    attrs: {
      "href": "https://www.huodongxing.com/event/1567573387600",
      "target": "_blank"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("往届回顾")])])]), _vm._v(" "), _c('div', {
    staticClass: "old-version"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2019/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/bufan2018/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2017/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2016/"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("FAQ-参会指南")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票什么时候截止?\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票截止日期为 2020年11月25日，中午12:00\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票付款成功后，如何获得参会凭证？\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。"), _c('br'), _vm._v("活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌微信公众号，届时也会有相应提醒。\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            请您核对票务权益，限量体验票、早鸟票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            大会场馆附近有就餐的地方吗？\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            酒店1层设有自助餐厅；距会场2-5分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                            1) 大会门票仅为“999元”票档开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                            2) 开票内容为：会议服务费； "), _c('br'), _vm._v("\n                            3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("合作机构")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('p', {
    attrs: {
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("会议地址")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        地铁10号线：金台夕照站 A口出，西行420米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        自驾：北京市朝阳区东三环中路七号，千禧大酒店\n                    ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://j.map.baidu.com/22/en",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("联系我们")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("白怡-Nina")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("159-0133-7648")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("baiyi@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注小饭桌")])])
}]}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-agenda-item']
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'item-wrap-small': _vm.data.speaker.length == 0
    }
  }, [(_vm.index == 0) ? _c('h2', {
    staticClass: "item-wrap-title-bg"
  }, [_vm._v(_vm._s(_vm.type.split('|')[0].substr(2, 10)))]) : _vm._e(), _vm._v(" "), (_vm.data.time.split('|')[1]) ? _c('h2', {
    staticClass: "item-wrap-title"
  }, [_vm._v(_vm._s(_vm.data.time.split('|')[1]))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-content"
  }, [_c('div', {
    staticClass: "a-content-wrap"
  }, [( false) ? _c('div', {
    staticClass: "left"
  }, [(false) ? _c('div', {
    staticClass: "name-title"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "t-name"
  }, [_vm._v(" " + _vm._s(_vm.data.time.split('|')[0]) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title",
    domProps: {
      "innerHTML": _vm._s(_vm.data.subject.split('|')[1])
    }
  }), _vm._v(" "), (_vm.data.speaker.length) ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker-title"
  }, [_vm._v("主持人：")]), _vm._v(" "), _c('div', {
    staticClass: "speaker-content"
  }, _vm._l((_vm.data.speaker), function(user) {
    return _c('p', [_vm._v(" " + _vm._s(user.name) + "　" + _vm._s(user.position))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.data.guest.length) ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker-title"
  }, [_vm._v("嘉　宾：")]), _vm._v(" "), _c('div', {
    staticClass: "speaker-content"
  }, _vm._l((_vm.data.guest), function(user) {
    return _c('p', [_vm._v(" " + _vm._s(user.name) + "　" + _vm._s(user.position))])
  }), 0)]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isPc()) ? _c('home-pc') : _c('home-mobile')], 1)
},staticRenderFns: []}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['agenda-item', {
      'agenda-item-bg-reverse': _vm.index % 2 == 0
    }]
  }, [(_vm.index == 0) ? _c('h2', {
    staticClass: "item-wrap-title-bg"
  }, [_vm._v(_vm._s(_vm.type.split('|')[0].substr(2, 10)))]) : _vm._e(), _vm._v(" "), (_vm.data.time.split('|')[1]) ? _c('h2', {
    staticClass: "item-wrap-title"
  }, [_vm._v(_vm._s(_vm.data.time.split('|')[1]))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-wrap",
    class: {
      'one-width': _vm.data.speaker.length == 1 || _vm.data.speaker.length == 0, 'double-width': _vm.data.speaker.length == 2, 'triple-width': _vm.data.speaker.length == 3
    }
  }, [_c('div', {
    staticClass: "agenda-title"
  }, [_c('div', {
    staticClass: "t-name"
  }, [_vm._v(" " + _vm._s(_vm.data.time.split('|')[0]) + " ")])]), _vm._v(" "), (_vm.data.subject.split('|')[0] == '圆桌论坛') ? _c('div', {
    staticClass: "a-content"
  }, [(_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('p', {
    staticClass: "bottom-title"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]) + " " + _vm._s(_vm.data.subject.split('|')[1]))])])]) : _c('div', {
    staticClass: "a-content"
  }, [( false) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title",
    domProps: {
      "innerHTML": _vm._s(_vm.data.subject.split('|')[1])
    }
  }), _vm._v(" "), (_vm.data.speaker.length) ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker-title"
  }, [_vm._v("主持人：")]), _vm._v(" "), _c('div', {
    staticClass: "speaker-content"
  }, _vm._l((_vm.data.speaker), function(user) {
    return _c('p', [_vm._v(" " + _vm._s(user.name) + "　" + _vm._s(user.position))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.data.guest.length) ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker-title"
  }, [_vm._v("嘉　宾：")]), _vm._v(" "), _c('div', {
    staticClass: "speaker-content"
  }, _vm._l((_vm.data.guest), function(user) {
    return _c('p', [_vm._v(" " + _vm._s(user.name) + "　" + _vm._s(user.position))])
  }), 0)]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-seciton"
    }
  }, [_vm._v("\n    hello top seciton         \n    "), _c('div', {
    staticClass: "test"
  }, [_vm._v("\n       test green \n    ")])])
}]}

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopSection__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePc__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HomePc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeMobile__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TopSection: __WEBPACK_IMPORTED_MODULE_0__components_TopSection___default.a,
    HomePc: __WEBPACK_IMPORTED_MODULE_1__components_HomePc___default.a,
    HomeMobile: __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile___default.a
  },
  methods: {
    isPc: function isPc() {
      return screen.width > 650 ? true : false;
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'type', 'index']
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MobileTicketItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgendaItem: __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem___default.a,
    TicketItem: __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem___default.a
  },
  data: function data() {
    return {
      whichDay: "Day1",
      showMenu: false,
      guestList: [],
      agendaData: {
        type: []
      },
      whichConf: "",
      whichHost: "",
      partnerList: [],
      currentAgendaMenu: [],
      activeAgendaMenu: "",
      currentAgendaData: [],
      showMoreFaq: false,
      showBottomNav: true,
      oldScrollY: 0,
      newScrollY: 0,
      oldGuests: __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__["a" /* default */],
      ticketUrl: "https://www.huodongxing.com/event/1567573387600",
      newsUrl: "https://www.xfz.cn/explore/xfz2019/news/"
    };
  },

  methods: {
    addListenScroll: function addListenScroll() {
      var self = this;
      window.onscroll = function (e) {
        self.newScrollY = window.scrollY;
        if (self.newScrollY - self.oldScrollY > 0) {
          self.showBottomNav = false;
        } else {
          self.showBottomNav = true;
        }
        self.oldScrollY = self.newScrollY;
      };
    },
    getGuestData: function getGuestData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: '/explore/xfz2020_api/guest/',
        method: 'get',
        success: function success(res) {
          if (res.code == 200) {
            self.guestList = res.data;
          }
        }
      });
    },
    getPartnerData: function getPartnerData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: '/explore/xfz2020_api/company/',
        method: 'get',
        success: function success(res) {
          if (res.code == 200) {
            self.partnerList = res.data;
          }
        }
      });
    },
    getAgendaData: function getAgendaData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: '/explore/xfz2020_api/meeting/',
        method: 'get',
        success: function success(res) {
          if (res.code == 200) {
            self.agendaData = res.data;
            self.activeAgendaMenu = self.agendaData.type[0][0];
            self.changeCurrentAgenda(self.activeAgendaMenu, 0);
          }
        }
      });
    },
    changeCurrentAgenda: function changeCurrentAgenda(agenda) {
      this.activeAgendaMenu = agenda;
      this.currentAgendaData = this.agendaData.meeting[agenda];
      this.whichConf = agenda.split("|")[0];
      this.whichHost = agenda.split("|")[1];
    },
    gotoSection: function gotoSection(section) {
      $("html,body").animate({ scrollTop: $("#" + section).offset().top }, 1000);
    }
  },
  mounted: function mounted() {
    document.title = '2020小饭桌青年创业者大会！';
    this.addListenScroll();
    this.getGuestData();
    this.getAgendaData();
    this.getPartnerData();
    __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].getWx();
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendaItem__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendaItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AgendaItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TicketItem__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TicketItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TicketItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        AgendaItem: __WEBPACK_IMPORTED_MODULE_0__AgendaItem___default.a, TicketItem: __WEBPACK_IMPORTED_MODULE_1__TicketItem___default.a
    },
    data: function data() {
        return {
            showNav: true,
            showAgendaMenu: false,
            showAgendaMenu2: true,
            guestList: [],
            partnerList: [],
            agendaData: {
                meeting: {},
                type: []
            },
            whichConf: '',
            whichHost: '',
            currentAgendaData: [],
            activeAgendaMenu: '',
            activeAgendaMenuIndex: 0,
            showMoreFaq: false,
            oldGuests: __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__["a" /* default */],
            ticketUrl: "https://www.xfz.cn/form/conference?acid=XaDLBoWpsm",
            newsUrl: "https://www.xfz.cn/explore/xfz2019/news/"
        };
    },

    methods: {
        getGuestData: function getGuestData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/xfz2020_api/guest/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.guestList = res.data;
                    }
                }
            });
        },
        getPartnerData: function getPartnerData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/xfz2020_api/company/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.partnerList = res.data;
                    }
                }
            });
        },
        getAgendaData: function getAgendaData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/xfz2020_api/meeting/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.agendaData = res.data;
                        self.activeAgendaMenu = self.agendaData.type[0][0];
                        self.changeCurrentAgenda(self.activeAgendaMenu, 0);
                    }
                }
            });
        },
        changeCurrentAgenda: function changeCurrentAgenda(agenda, index) {
            this.whichConf = agenda.split('|')[0];
            this.whichHost = agenda.split('|')[1];
            this.activeAgendaMenu = agenda;
            this.activeAgendaMenuIndex = index;
            this.currentAgendaData = this.agendaData.meeting[agenda];
        },
        gotoAgenda: function gotoAgenda(date) {
            location.href = "#s-agenda";
            if (date == 'date1') {
                this.changeCurrentAgenda(this.agendaData.type[0][0], 0);
            } else if (date == 'data2') {
                this.changeCurrentAgenda(this.agendaData.type[1][0], 4);
            }
        },
        gotoVipAgenda: function gotoVipAgenda(title) {
            this.whichConf = title.split('|')[0];
            this.whichHost = title.split('|')[1];
            this.changeCurrentAgenda(this.agendaData.type[0][4]);
        },
        listenScroll: function listenScroll() {
            var self = this;
            var offset = $('#participator-area').offset().top + 200;
            var flag = true;
            $(window).scroll(function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > offset) {
                    if (flag) {
                        flag = false;
                    }
                }
            });
        },
        runCountUp: function runCountUp() {
            var options = {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                suffix: '+'
            };
            var countup1 = new CountUp('countup-target1', 0, 3000, 0, 3.5, options);
            var countup2 = new CountUp('countup-target2', 0, 80, 0, 3.5, options);
            var countup3 = new CountUp('countup-target3', 0, 50, 0, 3.5, options);
            var countup4 = new CountUp('countup-target4', 0, 60, 0, 3.5, options);
            var countup5 = new CountUp('countup-target5', 0, 60, 0, 3.5, options);
            var countup6 = new CountUp('countup-target6', 0, 150, 0, 3.5, options);
            if (!countup1.error) {
                countup1.start();
                countup2.start();
                countup3.start();
                countup4.start();
                countup5.start();
                countup6.start();
            } else {
                console.error(demo.error);
            }
        }
    },
    mounted: function mounted() {
        document.title = '2020小饭桌青年创业者大会！';
        this.getGuestData();
        this.getPartnerData();
        this.getAgendaData();
        this.listenScroll();
    }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["data", "index", "type"]
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['data']
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['data']
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {



/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(11);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 53 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[52]);


// WEBPACK FOOTER //
// static/js/app.52d0c33d47a849f065a4.js